import { useState, useCallback } from 'react';

interface UseQuantityReturn {
  quantity: number;
  setQuantity: (value: number) => void;
  incrementQuantity: () => void;
  decrementQuantity: () => void;
}

export const useQuantity = (initialValue: number = 1, maxValue: number = 99): UseQuantityReturn => {
  const [quantity, setQuantityState] = useState<number>(initialValue);

  const setQuantity = useCallback((value: number) => {
    const newValue = Math.max(1, Math.min(value, maxValue));
    setQuantityState(newValue);
  }, [maxValue]);

  const incrementQuantity = useCallback(() => {
    setQuantity(quantity + 1);
  }, [quantity, setQuantity]);

  const decrementQuantity = useCallback(() => {
    setQuantity(quantity - 1);
  }, [quantity, setQuantity]);

  return {
    quantity,
    setQuantity,
    incrementQuantity,
    decrementQuantity
  };
}; 